/* ==========================================================================
   InputPanel > Templates > TooltipPanel
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');
const configuration = require('../client/js/config');
/**
 * Rating template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {object} Additional data to have available in the template
 */
/* eslint-disable camelcase */
module.exports = function Template(data, context = {}) {
    const style = configuration().css.self;
    const { content = '', type, placement = 'auto', panelStyle = '' } = data;

    const styles = [`${style}__panel`, panelStyle].join(' ');

    return html(`
        <div class='${styles}'
            data-component='Tooltip'
            data-type='${type}'
            role='tooltip'
            data-config='${JSON.stringify({
                context,
                placement
            })}'>
            <div class='${style}__wrapper'>
                <div ${configuration().hooks.panelContent}>${content}</div>
            </div>
        </div>`);
};
